<script setup lang="ts">
import type { InputBindableValue, InputOption, WithInputBindableModifiers } from '../types'
import YscInputGroup from './YscInputGroup.vue'
import YscInputRadio from './YscInputRadio.vue'
import { useModifiedValue } from '#imports'

interface Props extends WithInputBindableModifiers {
  id: string
  name: string
  modelValue: InputBindableValue
  options: InputOption<InputBindableValue>[]
  disabled?: boolean
  required?: boolean
  layoutColumn?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: null,
  disabled: false,
  required: false,
  layoutColumn: false,
  options: () => [],
  modelModifiers: () => ({}),
})

const emits = defineEmits<{
  'update:model-value': [InputBindableValue]
}>()

const onUpdateMpdelValue = ($event: InputBindableValue) => {
  emits('update:model-value', useModifiedValue({ props, value: $event }))
}
</script>

<template>
  <YscInputGroup
    :for="props.id"
    :required="props.required"
    :disabled="props.disabled"
  >
    <template
      v-if="$slots.default"
      #default
    >
      <slot />
    </template>

    <template #inputBlock>
      <div
        :class="props.layoutColumn ? 'columns-1 space-y-2' : 'flex flex-wrap gap-4'"
        class="relative"
      >
        <YscInputRadio
          v-for="option in props.options"
          :id="`radio_${name}_${option.value}`"
          :key="`radio_${name}_${option.value}`"
          :model-value="props.modelValue"
          :name="props.name"
          :value="option.value"
          :required="props.required"
          :disabled="props.disabled || option.disabled"
          is-block
          @update:model-value="onUpdateMpdelValue"
        >
          {{ option.text }}
        </YscInputRadio>
      </div>
    </template>

    <template
      v-if="$slots.description"
      #description
    >
      <slot name="description" />
    </template>
  </YscInputGroup>
</template>
